import { combineReducers } from "@reduxjs/toolkit";
import config from "./config";
import editor from "./editor/index";
import data from "./data/index";
const rootReducer = combineReducers({
  config,
  editor,
  data,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
